module.exports = __webpack_public_path__ + "static/image/audience-guide3.svg?dd192095f73667232246c7cf152475cb";